import { Component, Input, OnInit } from '@angular/core';
import { TenantType } from 'shared/constant';
//import { loadSlider } from 'common/slick-slider';

@Component({
  selector: 'app-left-part',
  templateUrl: './left-part.component.html',
  styleUrls: ['./left-part.component.css']
})
export class LeftPartComponent implements OnInit {
  @Input() descVersion: number = 0;
  TenantType = TenantType;

  constructor() { }

  ngOnInit(): void {
   // loadSlider();
  }

}
